<script setup="">
import { onMounted } from "vue";

import { useThemeStore } from "@/stores/theme";

const modeStore = useThemeStore();

onMounted(() => {
  modeStore.init();
});
</script>

<template><span></span></template>
